module.exports = __webpack_public_path__ + "static/img/sign_prize_pic.ebe84f3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/sign_prize_pic.png
// module id = +EDs
// module chunks = 1